import { render } from "./overview.vue?vue&type=template&id=4578faf9"
import script from "./overview.vue?vue&type=script&lang=js"
export * from "./overview.vue?vue&type=script&lang=js"
script.render = render

export default script